import { ThunkAction } from '../../../../../../../../types/actions';
import { TBoardId } from '../../../../../../../../types/types';
import { TStatus } from '../../../../../../../../types/model';
import { checklistsLoad } from '../../../../../../../../rest/effects/card/checklist/checklistsLoad';

export const loadChecklists = (
    boardId: TBoardId,
): ThunkAction => {
    return (
        dispatch,
        getState
    ) => {
        return dispatch(checklistsLoad(boardId, [TStatus.STATUS_ACTIVE, TStatus.STATUS_SERVICE_TEMPLATE]));
    }
}
